export default "__VITE_ASSET__805f8df2__"